import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page55() {
  useEffect(() => {
    document.title = "Маяк — Страница 54"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page53" />
        <ForwardLink href="/page55" />
      </div>

      <p style={{ textAlign: "right" }}>54.</p>
      <p>ВНУТРИ ДЕСЯТЬ ПОЛНЫХ БУТЫЛОК С ВЫПИВКОЙ.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (самому себе, иронично)<br/>
        Пайки.
      </p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – НОЧЬ</p>
      <p>
        ОБА ПЬЮТ, пока распределяют запасы. СТАРИК<br/>
        командует МОЛОДЫМ. Они уже изрядно пьяны.
      </p>
      <p>
        МОЛОДОЙ СМОТРИТ ЗАПИСИ в ЖУРНАЛЕ с отметками<br/>
        фунтов угля, количества банок, галлонов масла и т.д.
      </p>
      <p>СНАРУЖИ ДОЖДЬ БЬЕТ МОЛОТКОМ. ВОЕТ ВЕТЕР.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ... их десны распухли,<br/>
        стали цвета кости, затем начали гнить. Сочилась<br/>
        смолистая кровь, зубы падали на палубу,<br/>
        и никто их не собирал.
      </p>
      <p>СТАРИК с гордостью демонстрирует отсутствующие передние зубы.</p>
      <p style={{ textAlign: "center" }}>
        Их ноги засохли и покрылись<br/>
        гангреной, всех оттенков<br/>
        павлиньего хвоста. Самые плохие<br/>
        не могли противостоять корабельным крысам,<br/>
        которые грызли нам<br/>
        пятки.<br/>
        <br/>
        “Земля хо!”, – слышу я, но на этом<br/>
        острове только трава и деревья. Итак,<br/>
        мы пили сок и жрали<br/>
        траву. Это спасло нас<br/>
        от поедания друг друга,<br/>
        как это делают дикари. И именно<br/>
        эта цинга с тех пор оставила<br/>
        меня хромым.
      </p>
      <p>Он снова стучит по ноге.</p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Вы же сказали, что сломали ее.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Э?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Вашу ногу. Католички, и все<br/>
        такое.
      </p>
      <p style={{ textAlign: "right" }}>54.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page53" />
        <ForwardLink href="/page55" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710629044/the-lighthouse-script/yldiqjjhazdeofoecu31.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page55;
